import { render } from "./Admin.vue?vue&type=template&id=ae3e40c2&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ae3e40c2"

export default script